import Transformer from '@/transformers/transformer'

import moment from 'moment'
moment.locale('es-mx')

const supplyTransformer = function ({
  current_quantity:currentQuantity, is_approved: isApproved,
  iwarehouse_quantification_supply_id: iWarehouseQuantificationSupplyId,
  iwarehouse_supply_id: iWarehouseSupplyId, status,
  iwarehouse_supply_unit_cost: iWarehouseSupplyUnitCost,
  quantity_to_requested: quantityToRequest, supply_family: supplyFamily,
  supply_id: supplyId, supply_name: supplyName, supply_subfamily: supplySubFamily,
  supply_unit: supplyUnit, total_cost: totalCost, order_purchase: orderPurchase, requisition,
  has_config_iwarehouse_supply: hasConfig, rejected, rejected_comments: rejectedComments,
  supply_type_short_name: supplyType, supply_code: supplyCode
}, quantificationId) {
  return {
    currentQuantity: Number.parseFloat(currentQuantity).toFixed(6),
    isApproved,
    iWarehouseQuantificationSupplyId,
    quantificationSupplyIds: [iWarehouseQuantificationSupplyId],
    iWarehouseSupplyId,
    status,
    iWarehouseSupplyUnitCost,
    quantityToRequest: Number.parseFloat(quantityToRequest).toFixed(6),
    supplyFamily,
    supplyId,
    supplyName,
    supplySubFamily,
    supplyUnit,
    totalCost,
    quantificationId,
    // hasRequisitions,
    requisition,
    orderPurchase,
    hasConfig,
    rejected,
    rejectedComments,
    supplyType,
    supplyCode
  }
}

export default class sinisterSMTransformer extends Transformer {
  static fetch({
    last_update, added_date, affected_id: affectedId, affected_description: affectedDesc,
    affected_requisition_number: affectedRequisitionNumber, estimated_sale: estimatedSale,
    highway_name: highwayName, highway_section_id: highwaySectionId,
    highway_section_name: highwaySectionName, iwarehouse_id: iWarehouseId,
    iwarehouse_name: iWarehouseName, iwarehouse_quantification_id: iWarehouseQuantificationId,
    quantification_id: quantificationId, sinister_date_assignment, sinister_date_occurred,
    sinister_id: sinisterId, sinister_its_priority: sinisterItsPriority,
    sinister_its_urgent: sinisterItsUrgent, sinister_number: sinisterNumber,
    sinister_road_body: sinisterRoadBody, sinister_road_kilometer: sinisterRoadKilometer,
    sinister_road_meter: sinisterRoadMeter, sinister_type_of_job: sinisterTypeOfJob,
    status, supplies, sinister_road_id: sinisterRoadId, has_requisitions: hasRequisitions
  }) {

    const suppliesSM =  supplies.length > 0 ? supplies.map((s) => supplyTransformer(s, quantificationId)) : []
    const relatedOC =  suppliesSM.filter(({orderPurchase}) => !!orderPurchase).map(({orderPurchase}) => orderPurchase)
    return {
      affectedId,
      affectedDesc,
      affectedRequisitionNumber,
      estimatedSale,
      highwayName,
      highwaySectionId,
      highwaySectionName,
      iWarehouseId,
      iWarehouseName,
      iWarehouseQuantificationId,
      quantificationId,
      sinisterId,
      sinisterItsPriority,
      sinisterItsUrgent,
      sinisterNumber,
      sinisterRoadBody,
      sinisterRoadKilometer,
      sinisterRoadMeter,
      sinisterTypeOfJob,
      status,
      sinisterRoadId,
      hasRequisitions,
      showSupplies: false,
      supplies: suppliesSM,
      addedDate: moment(added_date).format('DD/MM/YYYY'),
      lastUpdate: moment(last_update).format('DD/MM/YYYY'),
      sinisterDateAssignment: moment(sinister_date_assignment).format('DD/MM/YYYY'),
      sinisterDateOcurred: moment(sinister_date_occurred).format('DD/MM/YYYY'),

      relatedOC: [...new Set(relatedOC)],
      seeMore: false
    }
  }

  // static send(data) {
  //   return {
  //   }
  // }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/sinistersInSM.js